<template>
  <!--This component should be wrapped in a relative container-->
  <div v-if="custom_layout.objects.length" :style="
    `position: relative;float: left;width: ${outer_width};height: ${outerHeight}px;`
  ">
    <div ref="custom_layout_outer_box" :style="
      `width: ${custom_layout.parent_width}px;height:${custom_layout.parent_height}px;position:absolute;`
    ">
      <vue-drag-resize v-for="(clo, clo_index) in custom_layout.objects" :key="`${clo._id}_CLO_${clo_index}`"
        :parentLimitation="true" :isActive="false" :preventActiveBehavior="true" :isResizable="false"
        :isDraggable="false" :w="clo.width" :h="clo.height" :x="clo.left" :y="clo.top" :minh="10"
        :contentClass="getVueDragResizeClassName(clo.type)">
        <show-custom-layout-object v-model="custom_layout.objects[clo_index]"
          :key="`${clo._id}_CLO_${clo_index}_COMPONENT`"></show-custom-layout-object>
      </vue-drag-resize>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ShowCustomLayoutObject from "@/components/Question/CustomLayout/ShowCustomLayoutObject";

export default {
  name: "view-question",
  refs: ["custom_layout_outer_box"],
  components: {
    ShowCustomLayoutObject,
  },
  props: {
    custom_layout: {
      type: Object,
      required: true,
    },
    outer_width: {
      type: String,
      default: "100%",
    },
    is_outer_height_extra: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(['updateCurrentAnswer']),
    getVueDragResizeClassName(type) {
      const mapping = {
        'MULTI-CHARS': 'z-index-1'
      }
      const className = mapping[type] || ''
      return className
    }
  },
  computed: {
    ...mapGetters(["getTeacherToken"]),
    outerHeight() {
      let height = this.custom_layout.parent_height;
      if (this.is_outer_height_extra) {
        height += 20;
      }
      return height;
    },
    scaleFactor() {
      let width = 0.1,
        height = 0.1; //Cannot give zero as this vue-drag-resize library needs greater than zero width and height
      if (this.$refs.custom_layout_outer_box) {
        width = this.$refs.custom_layout_outer_box.clientWidth;
        height = this.$refs.custom_layout_outer_box.clientHeight;
      }

      const scaleX = width / this.custom_layout.parent_width;
      const scaleY = height / this.custom_layout.parent_height;
      return {
        x: scaleX,
        y: scaleY,
      };
    },
  },
  watch: {
    custom_layout: {
      handler(new_val) {
        this.updateCurrentAnswer({
          key: "custom_layout",
          value: {
            objects: new_val.objects.filter(obj => ["INPUT", "MULTI-CHARS"].includes(obj.type))
          }
        })
      },
      deep: true,
    },
  },
  async created() { },
};
</script>
<style scoped>
.z-index-1 {
  z-index: 1 !important;
}
</style>
